import { isArray } from 'util';
import { sortByNumber } from '../../utils/collection.utils';
import { MachineGroup } from '../machine-group';
import { MachineGroupScheduleTimeRangeBuilder } from './machine-group-schedule-time-range.builder';
import { MachineGroupSectionBuilder } from './machine-group-section.builder';

export class MachineGroupBuilder {
  static fromJson(json) {
    return (json)
      ? new MachineGroup(
        json.hash,
        json.name,
        json.models,
        json.workingModelGroupTimeRanges ?
         MachineGroupScheduleTimeRangeBuilder.fromList(sortByNumber('startDate', json.workingModelGroupTimeRanges)) :
         [],
        MachineGroupSectionBuilder.fromList(json.sections)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(MachineGroupBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/machine-group.builder.ts